import {
  PRODUCT_CATEGORIES_ALL,
  PRODUCT_CATEGORIES_BREAD,
  PRODUCT_CATEGORIES_FRESH,
  PRODUCT_CATEGORIES_OTHER
} from '@const/common'

export default class ProductionRow {
  constructor(
    brands = [],
    teams = [],
    productionDateFrom = null,
    productionDateTo = null,
    productCategory = null,
    deliveryDateFrom = null,
    deliveryDateTo = null,
    selectProductCategoryName = null
  ) {
    this.id = Symbol()
    this.brands = brands
    this.teams = teams
    this.productionDateFrom = productionDateFrom
    this.productionDateTo = productionDateTo
    this.productCategory = productCategory
    this.deliveryDateFrom = deliveryDateFrom
    this.deliveryDateTo = deliveryDateTo
    this.selectProductCategoryName = selectProductCategoryName
  }

  update(data) {
    this.brands = data.brands
    this.teams = data.teams
    this.productionDateFrom = data.productionDateFrom
    this.productionDateTo = data.productionDateTo
    this.productCategory = data.productCategory
    this.deliveryDateFrom = data.deliveryDateFrom
    this.deliveryDateTo = data.deliveryDateTo
    this.selectProductCategoryName = data.selectProductCategoryName
  }

  get isValid() {
    if (this.selectProductCategoryName === PRODUCT_CATEGORIES_FRESH || this.selectProductCategoryName === PRODUCT_CATEGORIES_BREAD) {
      return Boolean(this.deliveryDateFrom && this.deliveryDateTo)
    }

    if (this.selectProductCategoryName === PRODUCT_CATEGORIES_OTHER || this.selectProductCategoryName === PRODUCT_CATEGORIES_ALL) {
      return Boolean(this.productionDateFrom && this.productionDateTo)
    }

    return false
  }
}
